import { render, staticRenderFns } from "./ProjectViewSidebar.vue?vue&type=template&id=aa6365ce"
import script from "./ProjectViewSidebar.vue?vue&type=script&lang=ts"
export * from "./ProjectViewSidebar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports